<template>
  <div class="verifyWrap">
    <Header></Header>
    <div class="verifyContent">
      <div class="fxRow pt80">
        <p class="green fs56 el-icon-success"></p>
      </div>
      <div class="bullshit">
        <p class="bullshit__headline">
          <span>{{ $t("login.remind.title") }}</span>
        </p>
        <p class="bullshit__info">
          <span v-if="type == 1">{{ $t("login.remind.hint") }}</span>
          <span v-if="type == 2">{{ $t("login.remind.hint02") }}</span>
        </p>
        <router-link to="/login" class="linkTo">
          <el-button type="primary" size="small" round>{{ $t("verify.login") }}</el-button>
        </router-link>
      </div>
    </div>
    <div class="footBox">
      <p class="black88 fs12">
        {{ $t("login.copyright") }}
        <a href="https://beian.miit.gov.cn/" target="_blank" class="blue">{{ $t("login.records") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
export default {
  name: "Remind",
  data() {
    return {
      type: 1,
    };
  },
  components: {
    Header,
  },
  methods: {},
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    } else {
      // 缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.$router.replace({ path: "/" });
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.bullshit {
  padding: 26px 0 30px;
  overflow: hidden;
  text-align: center;
}
.bullshit__oops {
  font-size: 32px;
  line-height: 40px;
  color: #1482f0;
  margin-bottom: 40px;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__headline {
  font-size: 26px;
  color: #222;
  margin-bottom: 6px;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__info {
  font-size: 16px;
  color: grey;
  margin-bottom: 30px;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}

.footBox {
  position: absolute;
  bottom: 14px;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 10000;
}
</style>
